// extracted by mini-css-extract-plugin
export default {"Virtual":"virtual_Virtual__EXiFo","left":"virtual_left__UpjUQ","wrapper":"virtual_wrapper__EosEh"};